import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetPublicityService } from '../generales/services/get-publicity.service';

@Injectable({
  providedIn: 'root'
})
export class PublicityService {
  url: string = environment.url;
  private posExample = [
    {
      id: '1',
      url: null,
    },
    {
      id: '2',
      url: null,
    },
    {
      id: '3',
      url: null,
    },
    {
      id: '4',
      url: null,
    },
    {
      id: '5',
      url: null,
    },
  ];
  private urlImage:string = `${environment.url}/file/publicity`
  constructor(
    private publicityService: GetPublicityService,
    private httpClient: HttpClient
  ) { }
  
  getPublicity(types, pos, slides?){
    return new Promise<any[]>(resolve => {
      this.publicityService.getPublicityTypes(types, pos).subscribe((res: any) => {
        const posFiltered = res.data.filter(idPos => idPos.positionId === pos);
          // posFiltered.forEach(x => {
          //   if(!x.action.includes('http')) x.action = `https://${x.action}`;
          //   x.file = `${this.urlImage}/${x.file}`
          // });
        resolve(posFiltered);
      });
    })
  }

  postPublicity(body, type = 'store'){
    return new Promise((resolve) => {
      this.httpClient.post(`${this.url}/publicity/${type}`, body).subscribe(res => {
        resolve(res)
      })
    })
  }

  deletePublicity(body){
    return new Promise((resolve) => {
      this.httpClient.post(`${this.url}/admin/publicity/approved`, body).subscribe(res => {
        resolve(res);
      })
    })
  }
}